/**
 * Wow family api
 * The Wow family API description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TriggerDto { 
    createdAt: string;
    updatedAt: string;
    id: string;
    name: string;
    description: string;
    /**
     * Enum of (* * * * * *|*_/5 * * * * *|*_/10 * * * * *|*_/30 * * * * *|*_/1 * * * *|0 *_/5 * * * *|0 *_/10 * * * *|0 *_/30 * * * *|0 0-23/1 * * *|0 0-23/2 * * *|0 0-23/3 * * *|0 0-23/4 * * *|0 0-23/5 * * *|0 0-23/6 * * *|0 0-23/7 * * *|0 0-23/8 * * *|0 0-23/9 * * *|0 0-23/10 * * *|0 0-23/11 * * *|0 0-23/12 * * *|0 01 * * *|0 02 * * *|0 03 * * *|0 04 * * *|0 05 * * *|0 06 * * *|0 07 * * *|0 08 * * *|0 09 * * *|0 10 * * *|0 11 * * *|0 12 * * *|0 13 * * *|0 14 * * *|0 15 * * *|0 16 * * *|0 17 * * *|0 18 * * *|0 19 * * *|0 20 * * *|0 21 * * *|0 22 * * *|0 23 * * *|0 0 * * *|0 0 * * 0|0 0 * * 1-5|0 0 * * 6,0|0 0 1 * *|0 12 1 * *|0 *_/2 * * *|0 1-23/2 * * *|0 0 1 *_/2 *|0 0 1 *_/3 *|0 0 1 *_/6 *|0 0 1 1 *|0 *_/30 9-17 * * *|0 *_/30 9-18 * * *|0 *_/30 10-19 * * *|0 0 01 * * 1-5|0 0 02 * * 1-5|0 0 03 * * 1-5|0 0 04 * * 1-5|0 0 05 * * 1-5|0 0 06 * * 1-5|0 0 07 * * 1-5|0 0 08 * * 1-5|0 0 09 * * 1-5|0 30 09 * * 1-5|0 0 10 * * 1-5|0 0 11 * * 1-5|0 30 11 * * 1-5|0 0 12 * * 1-5|0 0 13 * * 1-5|0 0 14 * * 1-5|0 0 15 * * 1-5|0 0 16 * * 1-5|0 0 17 * * 1-5|0 0 18 * * 1-5|0 0 19 * * 1-5|0 0 20 * * 1-5|0 0 21 * * 1-5|0 0 22 * * 1-5|0 0 23 * * 1-5|05 8-20 * * *|10 8-20 * * *|15 8-20 * * *|30 8 * * 1|0 10 * * 1|30 18 1 * *|30 18 15 * *|0 0 2 * *|0 12 2 * *|0 0 3 * *|0 12 3 * *|0 0 4 * *|0 12 4 * *|0 0 5 * *|0 12 5 * *|0 0 6 * *|0 12 6 * *|0 0 7 * *|0 12 7 * *|0 0 8 * *|0 12 8 * *|0 0 9 * *|0 12 9 * *|0 0 10 * *|0 12 10 * *|0 0 11 * *|0 12 11 * *|0 0 12 * *|0 12 12 * *|0 0 13 * *|0 12 13 * *|0 0 14 * *|0 12 14 * *|0 0 15 * *|0 12 15 * *|0 0 16 * *|0 12 16 * *|0 0 17 * *|0 12 17 * *|0 0 18 * *|0 12 18 * *|0 0 19 * *|0 12 19 * *|0 0 20 * *|0 12 20 * *|0 0 21 * *|0 12 21 * *|0 0 22 * *|0 12 22 * *|0 0 23 * *|0 12 23 * *|0 0 24 * *|0 12 24 * *|0 0 25 * *|0 12 25 * *|0 0 26 * *|0 12 26 * *|0 0 27 * *|0 12 27 * *|0 0 28 * *|0 12 28 * *|0 0 29 * *|0 12 29 * *|0 0 30 * *|0 12 30 * *|0 0 31 * *|0 12 31 * *|BY_ACTION_LOGIC|CANCELLED_ATTENDANCE_TO_EVENT|CONFIRMED_ATTENDANCE_TO_EVENT|EVENT_FINISHED|FILLED_BWA_REPORT|FILLED_SUCCESS_REPORT|NEW_EVENT_CREATED|USER_RECEIVED_NEW_REVIEW|WEBHOOK) but typed as a string due to OpenAPI Generator issues
     */
    value: string;
    type: TriggerDto.TypeEnum;
}
export namespace TriggerDto {
    export type TypeEnum = 'TIME' | 'EVENT' | 'SCENARIO' | 'WEBHOOK';
    export const TypeEnum = {
        Time: 'TIME' as TypeEnum,
        Event: 'EVENT' as TypeEnum,
        Scenario: 'SCENARIO' as TypeEnum,
        Webhook: 'WEBHOOK' as TypeEnum
    };
}


